import { api, fetcher, wrappedCollectionFetcher } from "services/api.service";
import { defaultMovementAction, MovementAction } from "types/locationManagement/movementAction";
import { LocationManagementLocationType } from "types/locationManagement/locationType";
import { redirect } from "react-router-dom";
import { withActionErrorAlert } from "utils/withActionError";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async ({ params }: { params: Record<string, string | undefined> }) => {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  let action = defaultMovementAction;
  if (params.movementActionId) {
    const res = await fetcher<MovementAction>(`/location_management/movement_actions/${params.movementActionId}`);
    action = res;
  }
  const locationTypesRes = await wrappedCollectionFetcher<LocationManagementLocationType>(
    "/location_management/location_types?page[size]=100",
  );
  const locationTypes = locationTypesRes.rows || [];
  return { action, locationTypes };
});

export async function action({ request, params }: { request: Request; params: Record<string, string | undefined> }) {
  const formData = await request.formData();
  const res = await withActionErrorAlert(() =>
    api.request({
      method: "PUT",
      url: `/location_management/movement_actions/${params.movementActionId}`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  );
  if (res?.status === 200) {
    return redirect("/movement-actions");
  }
  return res;
}
